import { useQuery } from 'react-query';
import { useContext } from 'react';
import { FetchContext } from 'context/FetchContext';

function useReorderPodcastList(data = {}) {
  const { enabled = true, queryKey = ['podcast-reorder-podcast'] } = data;
  const { privateFetch } = useContext(FetchContext);

  const fetchReorderPodcasts = async () => {
    const response = await privateFetch.get('/v1/admin/podcast/podcasts/reorder');
    return response?.data?.data || [];
  };

  return useQuery(queryKey, fetchReorderPodcasts, {
    enabled,
    keepPreviousData: false,
    cacheTime: 0,
    staleTime: 0,
    refetchOnWindowFocus: false,
    refetchOnMount: true,
  });
}

export default useReorderPodcastList;
